// src/app/core/services/device-id.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceIdService {
  private readonly STORAGE_KEY = 'device_id';
  private deviceId: string | null = null;

  getDeviceId(): string {
    if (this.deviceId) return this.deviceId;

    let id = localStorage.getItem(this.STORAGE_KEY);
    if (!id) {
      id = this.generateUuid();
      localStorage.setItem(this.STORAGE_KEY, id);
    }
    this.deviceId = id;
    return id;
  }

  private generateUuid(): string {
    // crypto.randomUUID is supported on all modern mobile/web webviews used by Capacitor
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    // fallback
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}